

export const constant = {
    USER_PROFILE_FETCH_IN_PROGRESS: "USER_PROFILE_FETCH_IN_PROGRESS",
    USER_PROFILE_FETCH_IN_COMPLETE: "USER_PROFILE_FETCH_IN_COMPLETE",
    USER_PROFILE_FETCH_IN_FAILED: "USER_PROFILE_FETCH_IN_FAILED",
    UPDATE_USER_ACTIVE_SCHOOL_IN_PROGRESS: "UPDATE_USER_ACTIVE_SCHOOL_IN_PROGRESS",
    UPDATE_USER_ACTIVE_SCHOOL_COMPLETE: "UPDATE_USER_ACTIVE_SCHOOL_COMPLETE",
    SET_ACTIVE_PROFILE_TYPE: "SET_ACTIVE_PROFILE_TYPE",
    SET_ACTIVE_SCHOOL: "SET_ACTIVE_SCHOOL",
   
    UPDATE_PROFILE_IN_PROGRESS: "UPDATE_PROFILE_IN_PROGRESS",
    UPDATE_PROFILE_IN_COMPLETE: "UPDATE_PROFILE_IN_COMPLETE",

    MAKE_OWNER_IN_PROGRESS :"MAKE_OWNER_IN_PROGRESS",
    MAKE_OWNER_SUCCESS :"MAKE_OWNER_SUCCESS",
    MAKE_OWNER_FAILURE : "MAKE_OWNER_FAILURE"
}